jQuery(document).ready(function ($) {
  const arrayUrl = {
    "/collections/on-water-catering": "https://store.royalmotor.com.au/product-category/on-water-catering/",
    "/pages/drinks-on-board-homepage": "https://store.royalmotor.com.au/product-category/drinks-on-board/",
    "/pages/memberships" : "https://store.royalmotor.com.au/product-category/membership/",
    "/pages/membership" : "https://store.royalmotor.com.au/product-category/membership/",
    
  };

  // Duyệt qua tất cả thẻ <a>
  $('a').each(function () {
    const currentHref = $(this).attr('href');
    if (currentHref && arrayUrl[currentHref]) {
      $(this).attr('href', arrayUrl[currentHref]);
    }
  });

});